<template>
  <v-footer
    class="grey darken-3"
    >
    <v-container
      fluid>
      <v-row
        justify=center>
        <v-btn
          class="main--text font-weight-bold"
          v-for="(link, index) in links"
          :key="index"
          color="white"
          text
          @click="$router.push({path: link.path})"
          >{{ link.title }}
        </v-btn>
      </v-row>
      <v-row
        justify=start>
        <v-col
          color="grey darken-3"
          class="white--text"
        >
          &copy;2019 — <strong>Prosense</strong>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
export default {
  data () {
    return {
      links: [
        {title: 'home', path: '/'},
        {title: 'お問い合わせ', path: '/contact'},
        {title: 'プライバシーポリシー', path: '/policy'}
      ]
    }
  }
}
</script>

<style scoped>

</style>